module.exports = (__webpack_require__(7472))(2340);